// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"346":"aa584f96","632":"e0d98b20","980":"a1ebd149","985":"5aa2dba6"}[chunkId] + ".css";
};